import { render, staticRenderFns } from "./Scene21.vue?vue&type=template&id=6e5edd7c&scoped=true"
import script from "./Scene21.vue?vue&type=script&lang=js"
export * from "./Scene21.vue?vue&type=script&lang=js"
import style0 from "./Scene21.vue?vue&type=style&index=0&id=6e5edd7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5edd7c",
  null
  
)

export default component.exports